import { Link } from 'react-router-dom';

import { ButtonIcon, Flex } from 'components';

const LiveNavbar = () => {
  return (
    <Flex borderBottom="2px solid" borderColor="gray_200" justifyContent="flex-end">
      <Link to="/">
        <ButtonIcon
          width={{ m: 60, d: 80 }}
          height={{ m: 60, d: 80 }}
          justifyContent="center"
          icon="close"
          size="large"
          flexShrink={0}
          bg="transparent"
          color="primary_400"
          colorHover="primary_200"
          colorClick="primary_400"
          borderLeft="2px solid"
          borderColor="gray_200"
        />
      </Link>
    </Flex>
  );
};

export default LiveNavbar;
